import {
  Armchair,
  Armrest,
  Backrest,
  Bed,
  BedOpen,
  Box,
  Chair,
  ChristmasBells,
  ColorPallete,
  CustomerClub,
  Discount,
  DoubleBed,
  ExpressDelivery,
  Financing,
  FlatPack,
  Garden,
  Hands,
  Headboard,
  Home,
  House,
  Interior,
  Lamp,
  Mattress,
  Module,
  ModulSofa,
  OnlineCart,
  Plant,
  Receipt,
  Room,
  Rug,
  Sale,
  Seng,
  Sofa,
  Storage,
  Table,
  Tools,
} from '../icons';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { removeHiddenCharacters } from '../../utils';

type CampaignTabProps = {
  tab: {
    title: string;
    subtitle?: string;
    icon?: string;
    tabSlug: {
      current: string;
    };
  };
  active?: boolean;
  NextLink: any;
  basePath?: string;
};

const CampaignIcons: any = {
  Armchair: Armchair,
  Armrest: Armrest,
  Backrest: Backrest,
  Bed: Bed,
  BedOpen: BedOpen,
  Box: Box,
  Chair: Chair,
  ChristmasBells: ChristmasBells,
  ColorPallete: ColorPallete,
  CustomerClub: CustomerClub,
  Discount: Discount,
  DoubleBed: DoubleBed,
  ExpressDelivery: ExpressDelivery,
  Financing: Financing,
  FlatPack: FlatPack,
  Garden: Garden,
  Hands: Hands,
  Headboard: Headboard,
  Home: Home,
  House: House,
  Interior: Interior,
  Lamp: Lamp,
  Mattress: Mattress,
  Module: Module,
  ModulSofa: ModulSofa,
  OnlineCart: OnlineCart,
  Plant: Plant,
  Receipt: Receipt,
  Room: Room,
  Rug: Rug,
  Sale: Sale,
  Seng: Seng,
  Sofa: Sofa,
  Storage: Storage,
  Table: Table,
  Tools: Tools,
};

export const CampaignTab = ({
  tab,
  active = false,
  NextLink,
  basePath = '/kampanje',
}: CampaignTabProps) => {
  const Icon = CampaignIcons[tab.icon || 'Sale'];

  return (
    <NextLink
      href={`${basePath}${
        tab.tabSlug && tab.tabSlug.current !== '/'
          ? `/${removeHiddenCharacters(tab.tabSlug.current)}`
          : ''
      }`}
      className={twMerge(
        clsx(
          'w-full bg-secondary-20 rounded pl-4 pt-4 pb-4 hover:bg-secondary-40 flex gap-3',
          'md:flex-col md:gap-4 md:items-center md:p-4 md:text-center',
          {
            'bg-secondary-40': active,
          }
        )
      )}
    >
      <div>
        <Icon className="size-8" />
      </div>
      <div className="flex flex-col">
        <span className="cap-sm text-neutral-80 md:hd-base">{tab.title}</span>
        {tab.subtitle && (
          <span className="body-xs text-neutral-80">{tab.subtitle}</span>
        )}
      </div>
    </NextLink>
  );
};
